var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable } from 'mobx';
import { cachedSet } from '../../../utils/mobx/decorators/customComputed';
import { flatten, uniq } from '../../../utils/helper/lodash_replacements';
export class ActorImport {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get actor() {
        return this.parent;
    }
    get app() {
        return this.actor.context.app;
    }
    get relevantBiddersBase() {
        // question scene
        return uniq([
            ...this.app.actorBundles.activeBundles,
            this.app.location,
            ...this.app.location.locationSteps.allSteps,
            this.actor.context.questionParent || this.app.question,
        ]);
    }
    get relevantBidders() {
        return flatten(this.relevantBiddersBase.filter(b => !!b).map(bidder => bidder.exportingTree.allExportingActors));
    }
    // @cachedSet
    get allExportTraits() {
        if (!this.app)
            return [];
        return uniq(flatten(flatten(this.relevantBiddersBase
            .filter(b => !!b)
            .map(bidder => bidder.exportingTree.allExportingAspects.map(aspect => aspect.exports)))));
    }
    get exporttraitsMatchingActor() {
        return this.allExportTraits.filter(exporttrait => this.isExportTraitMatching(exporttrait));
    }
    isExportTraitMatching(exporttrait) {
        return !exporttrait.value.actorFilterFunctions.find(actorFilter => {
            return !actorFilter({ trait: exporttrait, a: this.actor });
        });
    }
}
__decorate([
    cachedSet
], ActorImport.prototype, "relevantBidders", null);
__decorate([
    cachedSet
], ActorImport.prototype, "exporttraitsMatchingActor", null);
